export const FORM_REGEX_VALIDATORS = {
	email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
	phone: /^\+?[1-9][0-9]{7,14}$/,
	textOnly:
		/^[A-Za-z\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF\s]+$/g,
	textArabicOnly: /^[\u0621-\u064A\u0660-\u0669 ]+$/g,
	numbersOnly: /^[0-9]*$/g,
	digitsDecimal: /^(0|[1-9]\d{0,8})(\.\d{0,9})?$/,
}

export type SocialPlatform = "facebook" | "instagram" | "tiktok" | "twitter"

/** Hosts we accept per platform (a leading "www." is ignored). */
const SOCIAL_HOSTS: Record<SocialPlatform, string[]> = {
	facebook: ["facebook.com", "fb.com", "fb.me"],
	instagram: ["instagram.com", "instagr.am"],
	tiktok: ["tiktok.com"],
	twitter: ["twitter.com", "x.com"],
}

/**
 * Social profile links are always OPTIONAL — an empty value is valid. But when a
 * host does fill one in it has to be a real profile URL on that platform, not an
 * arbitrary site or a bare handle. Accepts a scheme-less "instagram.com/name"
 * (https is assumed) and requires a path, since the bare domain is not a profile.
 */
export const isValidSocialUrl = (
	platform: SocialPlatform,
	value?: string | null
): boolean => {
	const raw = (value ?? "").trim()
	if (!raw) return true // optional
	if (/\s/.test(raw)) return false

	let url: URL
	try {
		url = new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`)
	} catch {
		return false
	}
	if (url.protocol !== "http:" && url.protocol !== "https:") return false

	const host = url.hostname.toLowerCase().replace(/^www\./, "")
	const allowed = SOCIAL_HOSTS[platform]
	if (!allowed?.some((h) => host === h || host.endsWith(`.${h}`))) return false

	// A bare domain ("instagram.com") points at no account.
	return url.pathname.replace(/\/+$/, "").length > 1
}
